import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en.json';
import ruTranslations from './locales/ru.json';
import ukTranslations from './locales/uk.json';

// Custom cookie handler for 1-year storage
const cookieHandler = {
    name: 'i18next',
    lookup() {
        const name = 'i18next=';
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return null;
    },
    cacheUserLanguage(lng) {
        // Set cookie with 1-year expiration
        const d = new Date();
        d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000)); // 1 year
        const expires = 'expires=' + d.toUTCString();
        document.cookie = `i18next=${lng};${expires};path=/`;
    }
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: enTranslations
            },
            ru: {
                translation: ruTranslations
            },
            uk: {
                translation: ukTranslations
            }
        },
        fallbackLng: 'en',
        lng: 'en', // Default language is English
        debug: false,
        interpolation: {
            escapeValue: false
        },
        detection: {
            order: ['cookie', 'navigator'],
            caches: ['cookie'],
            cookieMinutes: 525600, // 1 year in minutes
            lookupCookie: 'i18next',
            cookieDomain: window.location.hostname
        }
    });

// Override the default cookie handler
i18n.services.languageDetector.addDetector(cookieHandler);

export default i18n;
